import Vue from 'vue'

let timeId = null;
let callbacks = []

const stopTimer = () => {
    clearInterval(timeId);
    timeId = null;
}

const startTimer = (cb) => {
    registerTimerCallBack(cb)
    if (timeId) {
        return;
    }
    timeId = setInterval(() => {
        if (callbacks?.length) {
            for (let i = 0; i < callbacks.length; i++) {
                const cb = callbacks[i];
                const flag = cb && cb();
                if (flag) {
                    callbacks.splice(i, 1);
                    i --;
                }
            }
        } else {
            stopTimer()
        }
    }, 1000);
}

const registerTimerCallBack = (cb) => {
    if (Object.prototype.toString.call(cb) === "[object Function]") {
        callbacks.push(cb);
        return callbacks.length - 1;
    }
}



const removeRegisterTimerCallBack = (cb, index) => {
    if (index > -1) {
        callbacks.splice(index, 1);
        return;
    }
    if (cb) {
        const i = callbacks.findIndex(item => {
            return cb === item
        })
        callbacks.splice(i, 1);
        return;
    }
}

Vue.prototype.startTimer = startTimer;
Vue.prototype.stopTimer = stopTimer;
Vue.prototype.registerTimerCallBack = registerTimerCallBack;
Vue.prototype.removeRegisterTimerCallBack = removeRegisterTimerCallBack;

